'use strict';
var FocusLayerStyle;
(function (FocusLayerStyle) {
    FocusLayerStyle["Darken"] = "darken";
    FocusLayerStyle["Blur"] = "blur";
})(FocusLayerStyle || (FocusLayerStyle = {}));
export default FocusLayerStyle;
